import { io, Socket } from "socket.io-client";

let socket: Socket | null = null;

export const getSocket = () => {
    if (!socket) {
        // Use the same origin as the frontend
        socket = io({
            path: "/api/socket",
            addTrailingSlash: false,
            // Start with polling for reliability, then upgrade to websocket
            transports: ["polling", "websocket"],
            reconnectionAttempts: 15,
            reconnectionDelay: 2000,     // 2s delay (balance between speed and spam)
            timeout: 20000,
        });

        socket.on("connect", () => {
            console.log("🔌 Connected to Socket.IO server");
        });

        socket.on("disconnect", (reason) => {
            console.log("📴 Disconnected from Socket.IO server:", reason);
        });

        let lastInitPing = 0;
        socket.on("connect_error", async (err) => {
            console.error("❌ Socket connection error:", err.message);

            // If the server hasn't been initialized yet, hit the API route to start it
            // Only ping every 10 seconds to avoid spamming the server
            const now = Date.now();
            if (now - lastInitPing > 10000 && (err.message === "xhr poll error" || err.message === "websocket error")) {
                lastInitPing = now;
                try {
                    await fetch("/api/socket");
                } catch (fetchErr) {
                    console.error("Failed to ping socket init route:", fetchErr);
                }
            }
        });
    }
    return socket;
};
